var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBug(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0h24v24H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M23 13.285c-.02.681-.595 1.215-1.276 1.215h-2.162v.625c0 .854-.19 1.663-.53 2.388l2.352 2.353a1.25 1.25 0 01-1.768 1.768l-2.138-2.138a5.602 5.602 0 01-3.54 1.254v-9.531c0-.26-.21-.469-.47-.469h-.937a.469.469 0 00-.469.469v9.531a5.602 5.602 0 01-3.54-1.254l-2.138 2.138a1.25 1.25 0 01-1.768-1.768l2.353-2.353a5.61 5.61 0 01-.532-2.388V14.5H4.276c-.681 0-1.257-.534-1.276-1.215A1.251 1.251 0 014.25 12h2.187V9.705l-1.82-1.821a1.25 1.25 0 111.767-1.768L8.518 8.25h8.964l2.134-2.134a1.25 1.25 0 011.768 1.768l-1.822 1.821V12h2.188A1.25 1.25 0 0123 13.285zM13.039 2a4.375 4.375 0 00-4.375 4.375h8.75A4.375 4.375 0 0013.039 2z"
  }))));
}

export default SvgBug;